import React from "react";
import "./Why_Partner_With_Us.css";
import Common_Title from "../../common_components/common_title/Common_Title";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";

const Why_Partner_With_Us = () => {
  const PartnerData = [
    "/assets/images/home/partner_with_us/img1.png",
    "/assets/images/home/partner_with_us/img2.png",
    "/assets/images/home/partner_with_us/img3.png",
    "/assets/images/home/partner_with_us/img4.png",
    "/assets/images/home/partner_with_us/img5.png",
    "/assets/images/home/partner_with_us/img6.png",
    "/assets/images/home/partner_with_us/img7.png",
    "/assets/images/home/partner_with_us/img8.png",
    "/assets/images/home/partner_with_us/img9.png",
  ];

  return (
    <section className="Why_Partner_With_Us">
      <div className="container">
        <div className="content_holder">
          <div className="row ">
            <div className="col-lg-5 col-md-12">
              <div className="text_content_holder">
                <h2 className="text_title">
                  <Common_Title simpleText="Why" darkText="Partner with Us?" />
                </h2>
                <p className="text_subtitle">
                  We have designed an EdTech model that
                  <span> eliminates industry roadblocks, </span>
                  making it the most advantageous and partner-friendly in India.
                </p>
              </div>
            </div>

            <div className="col-lg-7 col-md-12">
              <div className="image_content_holder">
                <Swiper
                  className="mySwiper_partner "
                  spaceBetween={5}
                  slidesPerView={3}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: true,
                  }}
                  pagination={true}
                  modules={[Autoplay, Pagination]}
                  breakpoints={{
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 10,
                    },
                    576: {
                      slidesPerView: 3,
                      spaceBetween: 10,
                    },
                    768: {
                      slidesPerView: 3,
                      spaceBetween: 10,
                    },
                    992: {
                      slidesPerView: 3,
                      spaceBetween: 10,
                    },
                    1200: {
                      slidesPerView: 3,
                      spaceBetween: 10,
                    },
                  }}
                >
                  {PartnerData.map((item, index) => (
                    <SwiperSlide>
                      <div className="img_holder">
                        <img
                          src={process.env.PUBLIC_URL + item}
                          className="logo_img"
                          alt="partner"
                        />
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why_Partner_With_Us;
